import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import Alert from '@material-ui/lab/Alert'
//const Functions = require('../../shared/Functions.js')
//const _ = require('lodash')
const $ = require('jquery')

const divStyle = {
  float: 'left',
  paddingLeft: '0px',
}

const aStyle = {
  display: 'none',
}

const h2Style = {
  display: 'none',
}

const ChangeForm = props => <Formik initialValues={{ id: props.employee.employee.id, old_password: '', new_password: '' }} enableReinitialize={true} validate={values => {
      const errors = {}
      if (!values.old_password) {
        errors.old_password = 'Required'
      } else if (!values.new_password) {
        errors.new_password = 'Required'
      }
      return errors
    }} onSubmit={(values, { setSubmitting }) => {
      let body = ''
      body = JSON.stringify({id: props.employee.employee.id, old_password: values.old_password, new_password: values.new_password})
      const urlf = '/api/v1/change_password'
      const meth = 'POST'
      fetch(urlf, {
        method: meth,
        headers: {
          'Content-Type': 'application/json',
        },
        body: body,
      })
      .then(response => response.json())
      .then((data) => {
        if (data.type === 'user'){
          document.getElementById('mylink').click()
        } else {
          $('#myerror').show()
          console.error('err' + data)
        }
      })
      .catch((err) => {
        console.error('Error while changing password! ' + err)
      })
      setTimeout(() => {
        setSubmitting(false)
      }, 400)
    }}>{({ isSubmitting, errors}) => <Fragment><a href="/" id="mylink" style={aStyle}></a><div id="myerror" style={h2Style}><Alert color="error">There was a problem. Please try again!</Alert></div><div className="row col-sm-12 justify-content-top"><h3>Change password</h3></div><br /><Form><div className="row col-sm-12"><div className="col-sm-6" style={divStyle}><div><label htmlFor="old_password">Current password</label><br /><Field type="password" name="old_password" className={'form-control' + (errors.old_password ? ' is-invalid' : '')}></Field></div><ErrorMessage name="old_password" component="div"></ErrorMessage><br /><div><label htmlFor="new_password">New password</label><br /><Field type="password" name="new_password" className={'form-control' + (errors.new_password ? ' is-invalid' : '')}></Field></div><ErrorMessage name="new_password" component="div"></ErrorMessage><br /></div><div className="col-sm-12" style={divStyle}><button type="submit" disabled={isSubmitting}>Change</button></div><br /><br /></div></Form></Fragment>}</Formik>

ChangeForm.propTypes = {
  employee: PropTypes.object,
}

export default ChangeForm
